import { requestGetJSON } from '../../../../NonReact/common/API/REST/RESTAPIClient'
import { requestJSON } from '../../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../../NonReact/constants/REST'
import {
    getMessageDefinitionURL,
    getMessagesLanguagesURL,
    getMessagesTypesURL,
    NO_CACHE_TIME
} from '../../../../NonReact/constants/ApiConstants'
import {
    MessageDefinitionPutRequest,
    MessageDefinitionResponse,
    MessageLanguagesResponse,
    MessageMutationResponse,
    MessageTypesResponse
} from '../../../../NonReact/Types/MessagesTypes'

/**
 * Loads all available message types.
 */
export const getMessageTypes = (): Promise<Nullable<MessageTypesResponse>> =>
    requestGetJSON<MessageTypesResponse>(getMessagesTypesURL(), {
        cacheTime: NO_CACHE_TIME
    })

/**
 * Loads all selectable message languages.
 */
export const getMessageLanguages = (): Promise<Nullable<MessageLanguagesResponse>> =>
    requestGetJSON<MessageLanguagesResponse>(getMessagesLanguagesURL(), {
        cacheTime: NO_CACHE_TIME
    })

/**
 * Loads one message definition for the selected type and locale.
 *
 * @param typeId Selected message type id.
 * @param locale Selected locale, or empty string for the default entry.
 */
export const getMessageDefinition = (typeId: string, locale: string): Promise<Nullable<MessageDefinitionResponse>> =>
    requestGetJSON<MessageDefinitionResponse>(getMessageDefinitionURL(typeId, locale), {
        cacheTime: NO_CACHE_TIME
    })

/**
 * Creates or updates one message definition.
 *
 * @param typeId Selected message type id.
 * @param locale Selected locale, or empty string for the default entry.
 * @param payload Updated field values.
 */
export const putMessageDefinition = (
    typeId: string,
    locale: string,
    payload: MessageDefinitionPutRequest
): Promise<Nullable<MessageMutationResponse>> =>
    requestJSON<MessageMutationResponse, MessageDefinitionPutRequest>(getMessageDefinitionURL(typeId, locale), {
        method: RESTMethods.PUT,
        body: payload
    })

/**
 * Deletes one locale-specific message definition.
 *
 * @param typeId Selected message type id.
 * @param locale Selected locale, or empty string for the default entry.
 */
export const deleteMessageDefinition = (typeId: string, locale: string): Promise<Nullable<MessageMutationResponse>> =>
    requestJSON<MessageMutationResponse, null>(getMessageDefinitionURL(typeId, locale), {
        method: RESTMethods.DELETE
    })
